export const publicVersion = "2.8.1-54-g5b5e2b0a-2026-05-29T13-25-21Z";